module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_CementRoof.75ee44c4.jpg";